import axios from "axios";
import { BASE_URL, getAxiosConfig } from "../components/interface/Config";
import { apiHandler } from "./authService";

export const getConsults = async (
  patientId: string,
  page: number = 1,
  limit: number = 6,
  searchkey: string = "",
  fromDate: string = "",
  toDate: string = "",
  consultStatus: string = "",
  consultId: string = ""
) => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  try {
    const payload = {
      limit,
      page,
      searchkey,
      order_by: "id",
      dir: 1,
      from_date: fromDate,
      to_date: toDate,
      participant_ref_number: patientId,
      consult_status: consultStatus,
      consult_id: consultId,
    }
    const url        = `${BASE_URL}/resource/consults`;
    const response   = await apiHandler(token, 'GET',payload, url);

    if (!response) {
        throw new Error("No response received from the server");
    }

    // const response = await axios.get(
    //   `${BASE_URL}/resource/consults`,
    //   {
    //     params: {
    //       limit,
    //       page,
    //       searchkey,
    //       order_by: "id",
    //       dir: 1,
    //       from_date: fromDate,
    //       to_date: toDate,
    //       participant_ref_number: patientId,
    //       consult_status: consultStatus,
    //       consult_id: consultId,
    //     },
    //     headers: {
    //       ...getAxiosConfig().headers,
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
    return response.data;
  } catch (error) {
    console.error("Error fetching consults:", error);
    throw error;
  }
};

